const validate = values => {
    const errors = {};
    if(!values.patient_name) { errors.patient_name = 'Campo requerido'; } else if(values.patient_name.trim() === '') {errors.patient_name = 'Campo requerido'; }
    return errors;
};

export default validate;
